import {Http} from "oca-lib-web";
import DashboardDateUtil from "../util/DashboardDateUtil";
import moment from "moment";

export default class FlurryEventParamsAPI {

    public static eventsParamUri = "https://api-metrics.flurry.com/public/v1/data/eventParams/{0}/app;show=apiKey,name,id/paramValue/paramName/event;show=all";

    public static get(startDate:string, endDate:string, interval:string, apiKeys:Array<string>):Promise<Array<FlurryEventParamModel>> {
        return new Promise(async(resolve, reject) => {
            let query = {};
            query["token"] = process.env.REACT_APP_FLURRY_API_KEY;
            query["metrics"] = "count";
            query["dateTime"] = DashboardDateUtil.convertFlurryDate(startDate, interval) + "/" + DashboardDateUtil.convertFlurryDate(endDate, interval);
            query["filters"] = "app|apiKey-in[" + apiKeys.join(",") + "]";

            //let queryString = `token=${query['token']}&metrics=count&dateTime=${query['dateTime']}&filters=${query['filters']}`
            let flurryEventParamUri = this.eventsParamUri.replace("{0}", DashboardDateUtil.getDateInterval(interval));
            //console.log(`${flurryEventParamUri}?${queryString}`)
            let results = null;
            try {
                results = await Http.get(flurryEventParamUri, query);
                console.log(results);
            } catch (e) {
                console.error("Error fetching data from flurry", e);
            }

            if (results?.status == 400) {
                console.error(results.reason, results.description);
                resolve([]);
                return;
            } else if (!results || !results.rows) {
                console.error("No rows returned");
                resolve([]);
                return;
            }

            let eventParams:Array<FlurryEventParamModel> = [];
            console.log("Got number of rows: " + results.rows.length);
            for (let result of results.rows) {

                // Continue when we find an event param with a value
                let eventName = result["event|name"];
                if (eventName === "View Sponsor Banner" || eventName === "UserSession") {
                    continue;
                }

                let eventParam: FlurryEventParamModel = {
                    date: moment(result["dateTime"]).format("YYYYMMDD"),
                    appName: result["app|name"],
                    paramValue: result["paramValue|name"], // this is where the json is
                    eventName: result["event|name"],
                    count: result["count"]
                };
                eventParams.push(eventParam);
            }
            resolve(eventParams);
        })
    }

}